import {throttle, debounce} from "lodash/function";

const author_copyright = document.querySelector("span#author-copyright")
const footer_menu = document.querySelector("ul#footer-nav")
const footer_menu_li_list = footer_menu.querySelectorAll("li");
const footer_menu_li_count = footer_menu_li_list.length;
const toggle_dot_in_footer_nav = () => {
    const author_position = author_copyright.getBoundingClientRect();
    const footer_menu_li_first = footer_menu.querySelector("li:first-child");


    const menu_position = footer_menu_li_first.getBoundingClientRect();

    // on test chaque li du menu en regardant le prochain li
    footer_menu_li_list.forEach((item, index, array) => {
        if(index < footer_menu_li_count-1){
            const item_position = item.getBoundingClientRect();
            const nextItem = array[index + 1];
            const item_next_position = nextItem.getBoundingClientRect();
            if(item_position.top < item_next_position.top){
                item.classList.add('no-separator');
            }else{
                item.classList.remove('no-separator');
            }

        }
    })

    // Test pour voir si le menu du footer est sur une nouvelle ligne
    if(author_position.top < menu_position.top){
        footer_menu.classList.add('no-separator');
    }else{
        footer_menu.classList.remove('no-separator');
    }

}

const footer_navigation_init = () => {

    // Ajout de l'écouteur
    window.addEventListener('resize',  throttle(toggle_dot_in_footer_nav, 500));
    toggle_dot_in_footer_nav();
}

export default footer_navigation_init;